import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  Appointment,
  NgAppointments,
  NgAppointmentDetails,
  NgWcSearch
} from '@app/shared/interfaces/appointment.interface';
import { environment } from '@env/environment';
import { catchError, Observable, of } from 'rxjs';
import {AppointmentSearchParams} from "@app/shared/interfaces/appointmentSearchParams.interface";

@Injectable({
  providedIn: 'root'
})
export class WorkCompAppointmentsService {
  private readonly nextGenBaseUrl = `${environment.apiUrl}/nextgen/appointments`;

  constructor(
    private http: HttpClient
  ) {}

  getAppointments$(filter: AppointmentSearchParams): Observable<NgAppointments> {
    // Temporary practice id until we know how work comp users are assigned practices
    const sendParams = { ...filter }
    return this.http.get<NgAppointments>(this.nextGenBaseUrl, {
      params: sendParams
    });
  }

  getAppointmentDetails$(personId: string, appointmentId?: string, caseNumber?: string): Observable<NgAppointmentDetails> {
    // Temporary practice id until we know how work comp users are assigned practices
    let params = {};
    if(appointmentId) params = {appointmentId: appointmentId};
    if(caseNumber) params = {...params, caseNumber: caseNumber};
    return this.http.get<NgAppointmentDetails>(this.nextGenBaseUrl + '/' + personId, {
      params: params
    });
  }

  patientSearch$(filter: AppointmentSearchParams): Observable<NgWcSearch> {
    // Temporary practice id until we know how work comp users are assigned practices
    const sendParams = {
      ...filter,
      searchText: (filter.searchText ?? '').trim()
    };
    return this.http.get<NgWcSearch>(this.nextGenBaseUrl + '/search', {
      params: sendParams
    });
  }
}
